import { BatchEmptyState } from "@/app/(app)/batch/_components/batch-empty-state";

export default function BatchPage() {
  return <BatchEmptyState />;
}
